module.exports = __webpack_public_path__ + "operace-nosu_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_4_after.jpg
// module id = 1135
// module chunks = 0